import { ShoppingBag, MapPin, CreditCard, Utensils } from 'lucide-react';
import { motion } from 'framer-motion';
import step1 from '@/assets/images/Home .png';
import step2 from '@/assets/images/orderconfirm.png';
import step3 from '@/assets/images/orderpayment.png';
import step4 from '@/assets/images/orders.png';

function StepsGuide() {
  const steps = [
    {
      icon: ShoppingBag,
      title: "Discover & Choose",
      description:
        "Browse restaurants, groceries, supermarkets, and exclusive Mystery Bags near you.",
      image: step1,
    },
    {
      icon: MapPin,
      title: "Place Your Order",
      description:
        "Select your favorite items, choose delivery or pickup, and confirm your order.",
      image: step2,
    },
    {
      icon: CreditCard,
      title: "Secure Payment",
      description:
        "Pay safely using your preferred payment method with a fast and secure checkout.",
      image: step3,
    },
    {
      icon: Utensils,
      title: "Enjoy Your Order",
      description:
        "Receive your order or collect it at your convenience, and enjoy fresh food while saving more with Mystery Bags.",
      image: step4,
    },
  ];

  return (
    <div className="bg-linear-to-b from-green-50 to-white">
      {/* How Does It Work Section */}
      <section className="py-20 px-4">
        <div className="max-w-7xl mx-auto">
          {/* Section Header */}
          <motion.div
            className="text-center mb-20"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-4">
              How Does It Work?
            </h2>
             <motion.div
             className="w-24 h-1 bg-green-600 mx-auto"
             initial={{ width: 0 }}
              whileInView={{ width: 96 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.2 }}
            ></motion.div>
          </motion.div>

          {/* Steps Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-6">
            {steps.map((step, index) => (
              <motion.div
                key={index}
                className="flex flex-col items-center text-center group"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{
                  duration: 0.6,
                  delay: index * 0.15,
                  ease: 'easeOut'
                }}
              >
                {/* Phone Mockup */}
                <motion.div className="relative mb-8"
                  whileHover={{ scale: 1.05 }}
                  transition={{ duration: 0.3 }}
                >
                  <div className="aspect-9/18 h-[48vh] bg-white rounded-4xl shadow-2xl border-4 border-gray-900 overflow-hidden relative">
                    
                    {/* Phone Content */}
                    <div className="w-full h-full bg-white overflow-hidden">
                      <img
                        src={step.image}
                        alt={step.title}
                        className="w-full h-full object-contain"
                      />
                    </div>
                  </div>
                </motion.div>

                {/* Step Info */}
                <div className="space-y-3">
                  <h3 className="text-xl font-bold text-gray-900">
                    {step.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed max-w-xs mx-auto">
                    {step.description}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default StepsGuide;
